"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HBAOEffect = void 0;
const AOEffect_1 = require("../ao/AOEffect");
const AOPass_1 = require("../ao/AOPass");
const ao_utils_1 = require("../ao/shader/ao_utils");
const hbao_1 = require("./shader/hbao");
const finalFragmentShader = hbao_1.hbao.replace("#include <ao_utils>", ao_utils_1.ao_utils);
class HBAOPass extends AOPass_1.AOPass {
    // #region Constructors (1)
    constructor(camera, scene) {
        super(camera, scene, finalFragmentShader);
    }
}
class HBAOEffect extends AOEffect_1.AOEffect {
    // #endregion Properties (1)
    // #region Constructors (1)
    constructor(composer, camera, scene, options = AOEffect_1.AOEffect.DefaultOptions) {
        super(composer, camera, scene, new HBAOPass(camera, scene), Object.assign(Object.assign(Object.assign({}, AOEffect_1.AOEffect.DefaultOptions), HBAOEffect.DefaultOptions), options));
        // #region Properties (1)
        this.lastSize = { width: 0, height: 0, resolutionScale: 0 };
    }
}
exports.HBAOEffect = HBAOEffect;
//# sourceMappingURL=HBAOEffect.js.map